export default __webpack_public_path__ + "static/media/Superette.564b983b.jpg";